import { useEffect, useRef, useState } from "react";
import { wsUrl, getToken } from "@/lib/api";

/** Subscribes to backend WS. onEvent({type, data}) is called on each message. */
export const useWebSocket = (onEvent) => {
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const reconnectTimer = useRef(null);
  const onEventRef = useRef(onEvent);
  onEventRef.current = onEvent;

  useEffect(() => {
    const connect = () => {
      const token = getToken();
      if (!token) return;
      const url = wsUrl(token);
      if (!url) return;
      const ws = new WebSocket(url);
      wsRef.current = ws;

      ws.onopen = () => setConnected(true);
      ws.onclose = () => {
        setConnected(false);
        reconnectTimer.current = setTimeout(connect, 3000);
      };
      ws.onerror = () => {
        try { ws.close(); } catch (e) { /* ignore */ }
      };
      ws.onmessage = (ev) => {
        try {
          const msg = JSON.parse(ev.data);
          onEventRef.current?.(msg);
        } catch (e) {
          // ignore
        }
      };
    };
    connect();
    return () => {
      if (reconnectTimer.current) clearTimeout(reconnectTimer.current);
      try { wsRef.current?.close(); } catch (e) { /* ignore */ }
    };
  }, []);

  return { connected };
};
